const pause = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
async function request(payload: Record<string, unknown>) {
  for (let attempt = 0; attempt < 18; attempt++) {
    let response: Response;
    try {
      response = await fetch('/.netlify/functions/drive-import', {method:'POST',headers:{'Content-Type':'application/json'},credentials:'include',body:JSON.stringify(payload),signal:AbortSignal.timeout(25000)});
    } catch {
      if (attempt === 17) throw new Error('Connection to the import service failed. Saved photos are safe. Try importing again.');
      await pause(3000); continue;
    }
    const raw = await response.text();
    let data; try { data = JSON.parse(raw); } catch { data = null; }
    if (response.ok && data) return data;
    if ((data?.retryable || [502,503,504].includes(response.status)) && attempt < 17) { await pause(3000); continue; }
    throw new Error(data?.error || `Import request failed (HTTP ${response.status}). Check Netlify function logs.`);
  }
  throw new Error('Import service unavailable. Try again.');
}
export async function importDriveGallery(galleryId: string, progress: (text: string) => void, refresh: () => Promise<void>) {
  progress('Starting preview service… this may take a minute.');
  await request({action:'health'});
  const key = `pawtrait-import:${galleryId}`;
  let jobId = localStorage.getItem(key);
  if (!jobId) {
    const started = await request({action:'start',galleryId});
    jobId = started.jobId;
    localStorage.setItem(key, String(jobId));
  }
  try {
    for (;;) {
      const state = await request({action:'status',jobId});
      progress(`${state.processed} / ${state.total} checked · ${state.count} saved${state.current ? ` · ${state.current}` : ''}`);
      if (state.status !== 'running') {
        localStorage.removeItem(key);
        await refresh();
        if (state.status === 'failed') throw new Error(state.error || 'Import failed.');
        if (state.errors?.length) throw new Error(`${state.count} photos saved. ${state.errors.length} failed. ${state.errors.slice(0,3).map((e: {filename:string;error:string})=>`${e.filename}: ${e.error}`).join('\n')}\nImport again to retry failed photos.`);
        return state.count as number;
      }
      await pause(2500);
    }
  } catch (error) {
    // A restart loses job status, but each finished photo remains in Supabase.
    localStorage.removeItem(key);
    await refresh().catch(() => undefined);
    throw error;
  }
}
